import { render, staticRenderFns } from "./ItsLaborDailyDetail.vue?vue&type=template&id=cdd8fb96&scoped=true&"
import script from "./ItsLaborDailyDetail.vue?vue&type=script&lang=js&"
export * from "./ItsLaborDailyDetail.vue?vue&type=script&lang=js&"
import style0 from "./ItsLaborDailyDetail.vue?vue&type=style&index=0&id=cdd8fb96&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cdd8fb96",
  null
  
)

export default component.exports